import { createElement } from "react";
import { accent } from "../hooks/tokens.js";
import { GRAPH, ARTICLES } from "../data.js";

const CONCEPTS = {
  "c-routemap": "Brique commune à BGP, à la redistribution et à l'automatisation : un même objet de politique réutilisé partout.",
  "c-tags": "Marquer une route à l'entrée coûte moins cher que de la filtrer à la sortie sur dix équipements.",
  "c-mtu": "Toute encapsulation prélève des octets : le symptôme apparaît en TCP, jamais au ping.",
  "c-vrf": "Le cloisonnement par table de routage revient dans VXLAN, le WAN et la redistribution.",
};

// Graphe de liens entre fiches et notions transverses, disposé sur un cercle.
export function buildGraphView(ctx) {
  const { s, patch, go } = ctx;

  const N = GRAPH.nodes.length;
  const pos = {};
  GRAPH.nodes.forEach((n, i) => {
    const ang = (i / N) * Math.PI * 2 - Math.PI / 2;
    pos[n.id] = { x: 50 + 36 * Math.cos(ang), y: 50 + 39 * Math.sin(ang) };
  });
  const focus = s.graphFocus;
  const near = (id) => id === focus || GRAPH.edges.some((e) => (e[0] === focus && e[1] === id) || (e[1] === focus && e[0] === id));
  const edges = GRAPH.edges.map((e, i) => {
    const on = e[0] === focus || e[1] === focus;
    return createElement("line", { key: i,
      x1: pos[e[0]].x, y1: pos[e[0]].y, x2: pos[e[1]].x, y2: pos[e[1]].y,
      stroke: on ? accent : "oklch(0.86 0.01 85)",
      strokeWidth: on ? 0.35 : 0.18, vectorEffect: "non-scaling-stroke" });
  });
  const fnode = GRAPH.nodes.find((n) => n.id === focus) || GRAPH.nodes[0];
  const fart = ARTICLES.find((a) => a.id === focus);

  return {
    graphEdges: createElement("svg", { viewBox: "0 0 100 100", preserveAspectRatio: "none",
      style: { position: "absolute", inset: 0, width: "100%", height: "100%", zIndex: 1 } }, edges),
    graphNodes: GRAPH.nodes.map((n) => ({ label: n.label,
      left: pos[n.id].x + "%", top: pos[n.id].y + "%",
      opacity: near(n.id) ? "1" : "0.4",
      border: n.id === focus ? accent : n.concept ? "oklch(0.9 0.01 85)" : "oklch(0.86 0.012 85)",
      bg: n.id === focus ? "oklch(0.99 0.006 60)" : n.concept ? "oklch(0.985 0.005 85)" : "oklch(1 0 0)",
      color: n.id === focus ? accent : n.concept ? "oklch(0.48 0.015 60)" : "oklch(0.26 0.015 60)",
      onClick: () => patch({ graphFocus: n.id }),
      onHover: () => patch({ graphFocus: n.id }) })),
    graphFocusLabel: fnode.label,
    graphFocusDesc: fart ? fart.summary : (CONCEPTS[fnode.id] || ""),
    graphNeighbors: GRAPH.nodes.filter((n) => n.id !== focus && near(n.id)).map((n) => ({
      label: n.label, kind: n.concept ? "notion" : "fiche",
      onClick: () => patch({ graphFocus: n.id }) })),
    graphHasArticle: !!fart,
    graphOpen: () => { if (fart) go(fart.id); },
  };
}
